import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle';

import { updateCargoOrder } from 'actions/cargoes/orders';
import { Checkbox } from 'material-ui';
import helpers from 'helpers';
import { SHIPMENT, CRADLES_TO_BE_FOR } from 'constants/weightVolume';

const unitsWeight = ['mm', 'cm', 'm', 'feet', 'inch', 'lb', 'kg', 'mt'];
const unitsVolume = ['m3', 'cbm', 'cbf'];
const terms = ['molchopt', 'moloo', 'per unit', 'per meter'];

class WeightVolume extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            'Pipes not to be overstowed with other cargo': false,
            'Box shaped hold only': false,
            'Wooden dunnaging': false,
            'Pipes with flanges and not streight on ends': false,
        };

        this.onChangeWeight = this.onChangeWeight.bind(this);
        this.changeWeightUnits = this.changeWeightUnits.bind(this);

        this.onChangeVolume = this.onChangeVolume.bind(this);
        this.changeVolumeUnits = this.changeVolumeUnits.bind(this);
        this.onChangeDeviation = this.onChangeDeviation.bind(this);
        this.changeTerm = this.changeTerm.bind(this);
        this.changeDeviationSign = this.changeDeviationSign.bind(this);
        this.onToggleFreeze = this.onToggleFreeze.bind(this);
    }

    changeTerm(key, type) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[type][0].term = terms[key];
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChangeDeviation(e, type) {
        const value = helpers.clearLetters(e.target.value);
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[type][0].deviation = 
            value || undefined;

        const percentObj = type === 'unitsWeight' ? 
            { name: 'weightWithPercent', multiplier: 1000 } : { name: 'volumeWithPercent', multiplier: 1 };

        if (newCargoOrder.totalValues.isCalc) {
            newCargoOrder.totalValues[percentObj.name] = newCargoOrder.cargo.reduce((acc, item) => {
                const units = item.packing.pack[type][0];
                if (units.deviation && parseInt(units.value)) {
                    return acc + parseInt(parseInt(units.value) * ((units.deviation / 100) + 1));
                } else if (!units.deviation && parseInt(units.value)) {
                    return acc + parseInt(units.value);
                } 
                return acc + 0;
            }, 0) * percentObj.multiplier;
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    changeDeviationSign(e, type, sign) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[type][0].deviationSign[sign] = e.target.innerText;
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChangeWeight(e, index) {
        const value = helpers.clearLetters(e.target.value);
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsWeight[index].value = 
            value || undefined;

        if (newCargoOrder.totalValues.isCalc && index === 0) {
            newCargoOrder.totalValues.weight = newCargoOrder.cargo
                .reduce((acc, item) => acc + parseInt(item.packing.pack.unitsWeight[0].value), 0) * 1000;

            newCargoOrder.totalValues.weightWithPercent = newCargoOrder.cargo.reduce((acc, item) => {
                const uw = item.packing.pack.unitsWeight[0];
                if (uw.deviation && parseInt(uw.value)) {
                    return acc + parseInt(parseInt(uw.value) * ((uw.deviation / 100) + 1));
                } else if (!uw.deviation && parseInt(uw.value)) {
                    return acc + parseInt(uw.value);
                }
                return acc + 0;
            }, 0) * 1000;
        }

        if (
            +newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsWeight[0].value >
            +newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsWeight[1].value
        ) {
            newCargoOrder.validateErrors.push({
                field: 'packing.pack.unitsWeight.value',
                messages: ['Min is greater than max'],
            });
        } else {
            newCargoOrder.validateErrors = newCargoOrder.validateErrors
                .filter(obj => obj.field !== 'packing.pack.unitsWeight.value');
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    changeWeightUnits(e, key) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsWeight[0].unit = unitsWeight[key];
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChangeVolume(e, index) {
        const value = helpers.clearLetters(e.target.value);
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsVolume[index].value = 
            value || undefined;
        
        if (newCargoOrder.totalValues.isCalc && index === 0) {
            newCargoOrder.totalValues.volume = newCargoOrder.cargo
                .reduce((acc, item) => acc + parseInt(item.packing.pack.unitsVolume[0].value), 0);

            newCargoOrder.totalValues.volumeWithPercent = newCargoOrder.cargo.reduce((acc, item) => {
                const uv = item.packing.pack.unitsVolume[0];
                if (uv.deviation && parseInt(uv.value)) {
                    return acc + parseInt(parseInt(uv.value) * ((uv.deviation / 100) + 1));
                } else if (!uv.deviation && parseInt(uv.value)) {
                    return acc + parseInt(uv.value);
                } 
                
                return acc + 0;
            }, 0);
        }

        if (
            +newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsVolume[0].value >
            +newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsVolume[1].value
        ) {
            newCargoOrder.validateErrors.push({
                field: 'packing.pack.unitsVolume.value',
                messages: ['Min is greater than max'],
            });
        } else {
            newCargoOrder.validateErrors = newCargoOrder.validateErrors
                .filter(obj => obj.field !== 'packing.pack.unitsVolume.value');
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    changeVolumeUnits(e, key) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsVolume[0].unit = unitsVolume[key];
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onToggleFreeze(unit) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[unit][0].isCalc = 
            !newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[unit][0].isCalc;
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    /**
     * 
     * @param { 'temperatureMin' | 'temperatureMax' | 'moistureMin' | 'moistureMax' | 
     *  'numberOfHeadsMin' | 'numberOfHeadsMax' | 'weightPerHead' | 'ventilation' } field 
     * @param {*} value 
     */
    changeAdditionalPackingData = (field, value) => {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        const { pack } = newCargoOrder.cargo[this.props.cargoPackingIndex].packing;
        pack[field] = helpers.clearLetters(value);

        const workingOn = [
            { min: 'temperatureMin', max: 'temperatureMax' },
            { min: 'moistureMin', max: 'moistureMax' },
            { min: 'numberOfHeadsMin', max: 'numberOfHeadsMax' },
        ].find(f => f.max === field);

        if (workingOn) {
            if (pack[workingOn.min] && pack[workingOn.max]) {
                if (+pack[workingOn.min] > +pack[workingOn.max]) {
                    newCargoOrder.validateErrors.push({
                        field: `packing.pack.${workingOn.max}`,
                        messages: ['Min is greater than max'],
                    });
                } else {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors
                        .filter(obj => obj.field !== `packing.pack.${workingOn.max}`);
                }
            } else {
                newCargoOrder.validateErrors = newCargoOrder.validateErrors
                    .filter(obj => obj.field !== `packing.pack.${workingOn.max}`);
            }
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    /**
     * @param {string} _clause
     */
    changeClauses = (_clause) => {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        const clause = JSON.parse(_clause);

        this.setState({
            [clause.name]: clause.value,
        });

        const index = newCargoOrder.cargo[this.props.cargoPackingIndex].clauses
            .findIndex(c => c.name === clause.name);

        if (index >= 0) {
            newCargoOrder.cargo[this.props.cargoPackingIndex].clauses.splice(index, 1, clause);
        } else {
            newCargoOrder.cargo[this.props.cargoPackingIndex].clauses.push(clause);
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    };

    render() {
        const errorWeightValue = this.props.errorWeightValue ? this.props.errorWeightValue.messages[0] : '';
        const errorVolumeValue = this.props.errorVolumeValue ? this.props.errorVolumeValue.messages[0] : '';

        const temperatureMaxError = this.props.validateErrors
            .find(e => e.field === 'packing.pack.temperatureMax');

        const moistureMaxError = this.props.validateErrors
            .find(e => e.field === 'packing.pack.moistureMax');

        const numberOfHeadsMaxError = this.props.validateErrors
            .find(e => e.field === 'packing.pack.numberOfHeadsMax');

        const { 
            unitsWeight: packUnitsWeight, 
            unitsVolume: packUnitsVolume,
            temperatureMin,
            temperatureMax,
            moistureMin,
            moistureMax,
            numberOfHeadsMin,
            numberOfHeadsMax,
            weightPerHead,
            ventilation,
        } = this.props.cargoOrder.cargo[this.props.cargoPackingIndex].packing.pack;

        const { details, clauses } = this.props.cargoOrder.cargo[this.props.cargoPackingIndex];
        const shipment = JSON.stringify(clauses.find(c => c.name === 'Shipment'));
        const cradlesToBeFor = JSON.stringify(clauses.find(c => c.name === 'Cradles to be for'));

        return (
            <div style={{ fontSize: '14px' }}>
                <div className="row">
                    <div className='column-left' style={{ fontSize: '13px' }}>
                        Weight/Volume:
                    </div>
                </div>
                <div className='row'>
                    <div className='one-forth'>
                        Weight:
                    </div>
                    <div className='one-forth'>
                        <TextField
                            ref='unitWeightValue'
                            style={{ width: '80%', fontSize: '14px' }}
                            value={packUnitsWeight[0].value || ''}
                            floatingLabelText='Min'
                            onChange={e => this.onChangeWeight(e, 0)}
                        />
                    </div>
                    <div className='one-forth'>
                        <TextField
                            ref='unitWeightValue'
                            errorText={errorWeightValue}
                            style={{ width: '80%', fontSize: '14px' }}
                            value={packUnitsWeight[1].value || ''}
                            floatingLabelText='Max'
                            onChange={e => this.onChangeWeight(e, 1)}
                        />
                    </div>
                    <div className="one-forth">
                        <SelectField
                            floatingLabelText='Units'
                            style={{ width: '80%', fontSize: '14px' }}
                            value={packUnitsWeight[0].unit}
                            onChange={this.changeWeightUnits}
                            maxHeight={200}
                            autoWidth
                        >
                            {
                                unitsWeight.map((unit, key) => (<MenuItem
                                    key={key}
                                    style={{ width: 'auto' }}
                                    value={unit}
                                    primaryText={unit}
                                />))
                            }
                        </SelectField>
                    </div>
                </div>
                <div className='row'>
                    <div className='one-forth'>
                        <Toggle 
                            label="Freezed"
                            style={{ width: '60%', fontSize: '14px' }}
                            toggled={!!packUnitsWeight[0] && !packUnitsWeight[0].isCalc}
                            onToggle={() => this.onToggleFreeze('unitsWeight')}
                        />
                    </div>
                    <div className="one-forth">
                        <SelectField
                            style={{
                                width: '40%',
                                fontSize: '14px',
                            }}
                            floatingLabelText='Sign 1'
                            value={packUnitsWeight[0].deviationSign && packUnitsWeight[0].deviationSign.sign1}
                            onChange={e => this.changeDeviationSign(e, 'unitsWeight', 'sign1')}
                            maxHeight={200}
                            autoWidth
                        >
                            {
                                ['+', '-'].map((unit, key) => (<MenuItem
                                    key={key}
                                    style={{ width: 'auto' }}
                                    value={unit}
                                    primaryText={unit}
                                />))
                            }
                        </SelectField>
                        <SelectField
                            style={{
                                marginLeft: '10px',
                                width: '40%',
                                fontSize: '14px',
                            }}
                            floatingLabelText='Sign 2'
                            value={packUnitsWeight[0].deviationSign && packUnitsWeight[0].deviationSign.sign2}
                            onChange={e => this.changeDeviationSign(e, 'unitsWeight', 'sign2')}
                            maxHeight={200}
                            autoWidth
                        >
                            {
                                ['+', '-'].map((unit, key) => (<MenuItem
                                    key={key}
                                    style={{ width: 'auto' }}
                                    value={unit}
                                    primaryText={unit}
                                />))
                            }
                        </SelectField>
                    </div>
                    <div className="one-forth">
                        <TextField
                            ref='unitWeightDeviation'
                            style={{ width: '80%', fontSize: '14px' }}
                            value={packUnitsWeight[0].deviation || ''}
                            floatingLabelText='Deviation'
                            onChange={(e) => { this.onChangeDeviation(e, 'unitsWeight'); }}
                        />
                    </div>
                    <div className="one-forth">
                        <SelectField
                            style={{
                                width: '80%',
                                fontSize: '14px',
                            }}
                            floatingLabelText='Terms'
                            value={packUnitsWeight[0].term || ''}
                            onChange={(e, key) => { this.changeTerm(key, 'unitsWeight'); }}
                            maxHeight={200}
                            autoWidth
                        >
                            {
                                terms.map((term, key) => (<MenuItem
                                    key={key}
                                    style={{ width: 'auto' }}
                                    value={term}
                                    primaryText={term}
                                />))
                            }
                        </SelectField>
                    </div>
                </div>
                <div className='row'>
                    <div className='one-forth'>
                         Volume:
                    </div>
                    <div className='one-forth'>
                        <TextField
                            ref='unitVolumeValue'
                            style={{ width: '80%', fontSize: '14px' }}
                            value={packUnitsVolume[0].value || ''}
                            floatingLabelText='Min'
                            onChange={e => this.onChangeVolume(e, 0)}
                        />
                    </div>
                    <div className='one-forth'>
                        <TextField
                            ref='unitVolumeValue'
                            errorText={errorVolumeValue}
                            style={{ width: '80%', fontSize: '14px' }}
                            value={packUnitsVolume[1].value || ''}
                            floatingLabelText='Max'
                            onChange={e => this.onChangeVolume(e, 1)}
                        />
                    </div>
                    <div className='one-forth'>
                        <SelectField
                            style={{
                                width: '80%',
                                fontSize: '14px',
                            }}
                            floatingLabelText='Units'
                            value={packUnitsVolume[0].unit}
                            onChange={this.changeVolumeUnits}
                            maxHeight={200}
                            autoWidth
                        >
                            {
                                unitsVolume.map((unit, key) => (<MenuItem
                                    key={key}
                                    style={{ width: 'auto' }}
                                    value={unit}
                                    primaryText={unit}
                                />))
                            }
                        </SelectField>
                    </div>
                </div>
                <div className='row'>
                    <div className='one-forth'>
                        <Toggle 
                            label="Freezed"
                            style={{ width: '60%', fontSize: '14px' }}
                            toggled={!!packUnitsVolume[0] && !packUnitsVolume[0].isCalc}
                            onToggle={() => this.onToggleFreeze('unitsVolume')}
                        />
                    </div>
                    <div className='one-forth'>
                        <SelectField
                            style={{
                                width: '40%',
                                fontSize: '14px',
                            }}
                            floatingLabelText='Sign 1'
                            value={packUnitsVolume[0].deviationSign && packUnitsVolume[0].deviationSign.sign1}
                            onChange={e => this.changeDeviationSign(e, 'unitsVolume', 'sign1')}
                            maxHeight={200}
                            autoWidth
                        >
                            {
                                ['+', '-'].map((unit, key) => (<MenuItem
                                    key={key}
                                    style={{ width: 'auto' }}
                                    value={unit}
                                    primaryText={unit}
                                />))
                            }
                        </SelectField>
                        <SelectField
                            style={{
                                marginLeft: '10px',
                                width: '40%',
                                fontSize: '14px',
                            }}
                            floatingLabelText='Sign 2'
                            value={packUnitsVolume[0].deviationSign && packUnitsVolume[0].deviationSign.sign2}
                            onChange={e => this.changeDeviationSign(e, 'unitsVolume', 'sign2')}
                            maxHeight={200}
                            autoWidth
                        >
                            {
                                ['+', '-'].map((unit, key) => (<MenuItem
                                    key={key}
                                    style={{ width: 'auto' }}
                                    value={unit}
                                    primaryText={unit}
                                />))
                            }
                        </SelectField>
                    </div>
                    <div className='one-forth'>
                        <TextField
                            ref='unitVolumeDeviation'
                            style={{ width: '80%', fontSize: '14px' }}
                            value={packUnitsVolume[0].deviation || ''}
                            floatingLabelText='Deviation'
                            onChange={(e) => { this.onChangeDeviation(e, 'unitsVolume'); }}
                        />
                    </div>
                    <div className='one-forth'>
                        <SelectField
                            style={{
                                width: '80%',
                                fontSize: '14px',
                            }}
                            floatingLabelText='Terms'
                            value={packUnitsVolume[0].term}
                            onChange={(e, key) => { this.changeTerm(key, 'unitsVolume'); }}
                            maxHeight={200}
                            autoWidth
                        >
                            {
                                terms.map((unit, _key) => (<MenuItem
                                    key={unit}
                                    style={{ width: 'auto' }}
                                    value={unit}
                                    primaryText={unit}
                                />))
                            }
                        </SelectField>
                    </div>
                </div>
                <div className='row'>
                    <div className='one-forth' style={{ padding: '0 20px' }}>
                        <TextField
                            ref='temperatureMin'
                            style={{ fontSize: '13px' }}
                            value={temperatureMin || ''}
                            floatingLabelText='Temperature min, °C'
                            hintText='Temperature min, °C'
                            onChange={e => 
                                this.changeAdditionalPackingData('temperatureMin', e.target.value)
                            }
                        />
                    </div>
                    <div className='one-forth' style={{ padding: '0 20px' }}>
                        <TextField
                            ref='temperatureMax'
                            style={{ fontSize: '13px' }}
                            value={temperatureMax || ''}
                            errorText={temperatureMaxError && temperatureMaxError.messages[0]}
                            floatingLabelText='Temperature max, °C'
                            hintText='Temperature max, °C'
                            onChange={e => 
                                this.changeAdditionalPackingData('temperatureMax', e.target.value)
                            }
                        />
                    </div>
                    <div className='one-forth' style={{ padding: '0 20px' }}>
                        <TextField
                            ref='moistureMin'
                            style={{ fontSize: '13px' }}
                            value={moistureMin || ''}
                            floatingLabelText='Moisture min, %'
                            hintText='Moisture min, %'
                            onChange={e => 
                                this.changeAdditionalPackingData('moistureMin', e.target.value)
                            }
                        />
                    </div>
                    <div className='one-forth' style={{ padding: '0 20px' }}>
                        <TextField
                            ref='moistureMax'
                            style={{ fontSize: '13px' }}
                            value={moistureMax || ''}
                            errorText={moistureMaxError && moistureMaxError.messages[0]}
                            floatingLabelText='Moisture max, %'
                            hintText='Moisture max, %'
                            onChange={e => 
                                this.changeAdditionalPackingData('moistureMax', e.target.value)
                            }
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='one-forth' style={{ padding: '0 20px' }}>
                        <TextField
                            ref='numberOfHeadsMin'
                            style={{ fontSize: '13px' }}
                            value={numberOfHeadsMin || ''}
                            floatingLabelText='Number of heads (min)'
                            hintText='Number of heads (min)'
                            onChange={e => 
                                this.changeAdditionalPackingData('numberOfHeadsMin', e.target.value)
                            }
                        />
                    </div>
                    <div className='one-forth' style={{ padding: '0 20px' }}>
                        <TextField
                            ref='numberOfHeadsMax'
                            style={{ fontSize: '13px' }}
                            value={numberOfHeadsMax || ''}
                            errorText={numberOfHeadsMaxError && numberOfHeadsMaxError.messages[0]}
                            floatingLabelText='Number of heads (max)'
                            hintText='Number of heads (max)'
                            onChange={e => 
                                this.changeAdditionalPackingData('numberOfHeadsMax', e.target.value)
                            }
                        />
                    </div>
                    <div className='one-forth' style={{ padding: '0 20px' }}>
                        <TextField
                            ref='weightPerHead'
                            style={{ fontSize: '13px' }}
                            value={weightPerHead || ''}
                            floatingLabelText='Weight mt per head'
                            hintText='Weight mt per head'
                            onChange={e => 
                                this.changeAdditionalPackingData('weightPerHead', e.target.value)
                            }
                        />
                    </div>
                    <div className='one-forth' style={{ padding: '0 20px' }}>
                        <Checkbox 
                            label='Ventilation'
                            style={{ marginTop: '24px' }}
                            labelStyle={{ fontSize: '13px', fontWeight: 'normal' }}
                            value={ventilation}
                            onChange={() => this.changeAdditionalPackingData('ventilation', !ventilation)}
                        />
                    </div>
                </div>
                {
                    details === 1 ?
                        <div className='row'>
                            <div className='one-forth' style={{ padding: '0 20px' }}>
                                <SelectField
                                    style={{ fontSize: '14px' }}
                                    floatingLabelText='Shipment'
                                    value={shipment}
                                    onChange={(_e, _i, value) => { this.changeClauses(value); }}
                                    maxHeight={200}
                                    autoWidth
                                >
                                    {
                                        SHIPMENT.map(clause => (<MenuItem
                                            key={clause.value}
                                            style={{ width: 'auto' }}
                                            value={JSON.stringify(clause)}
                                            primaryText={clause.value}
                                        />))
                                    }
                                </SelectField>
                            </div>
                            <div className='one-forth' style={{ padding: '0 20px' }}>
                                <SelectField
                                    style={{ fontSize: '12px' }}
                                    labelStyle={{ paddingRight: '36px' }}
                                    floatingLabelText='Cradles to be for'
                                    iconStyle={{ height: '39px', width: '39px' }}
                                    value={cradlesToBeFor}
                                    onChange={(_e, _i, value) => { this.changeClauses(value); }}
                                    maxHeight={200}
                                    autoWidth
                                    fullWidth
                                >
                                    {
                                        CRADLES_TO_BE_FOR.map(clause => (<MenuItem
                                            key={clause.value}
                                            style={{ width: 'auto' }}
                                            value={JSON.stringify(clause)}
                                            primaryText={clause.value}
                                        />))
                                    }
                                </SelectField>
                            </div>
                        </div>

                        :
                        null
                }
                {
                    details === 2 ?
                        <React.Fragment>
                            <div className='row'>
                                <div className='one-forth' style={{ padding: '0 20px' }}>
                                    <SelectField
                                        style={{ fontSize: '14px' }}
                                        floatingLabelText='Shipment'
                                        value={shipment}
                                        onChange={(_e, _i, value) => { this.changeClauses(value); }}
                                        maxHeight={200}
                                        autoWidth
                                    >
                                        {
                                            SHIPMENT.map(clause => (<MenuItem
                                                key={clause.value}
                                                style={{ width: 'auto' }}
                                                value={JSON.stringify(clause)}
                                                primaryText={clause.value}
                                            />))
                                        }
                                    </SelectField>
                                </div>
                                <div className='one-forth' style={{ padding: '0 20px' }} />
                                <div style={{ padding: '0 20px' }}>
                                    <Checkbox 
                                        label='Pipes not to be overstowed with other cargo'
                                        style={{ marginTop: '24px' }}
                                        labelStyle={{ fontSize: '13px', fontWeight: 'normal', width: '100%' }}
                                        iconStyle={{ marginRight: '6px' }}
                                        checked={this.state['Pipes not to be overstowed with other cargo']}
                                        onCheck={() => this.changeClauses(JSON.stringify({
                                            name: 'Pipes not to be overstowed with other cargo',
                                            value: !this.state['Pipes not to be overstowed with other cargo'],
                                        }))}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='one-forth' style={{ padding: '0 20px 10px' }}>
                                    <Checkbox 
                                        label='Box shaped hold only'
                                        style={{ marginTop: '24px' }}
                                        labelStyle={{
                                            fontSize: '12px', fontWeight: 'normal', width: '100%',
                                        }}
                                        iconStyle={{ marginRight: '6px' }}
                                        checked={this.state['Box shaped hold only']}
                                        onCheck={() => this.changeClauses(JSON.stringify({
                                            name: 'Box shaped hold only',
                                            value: !this.state['Box shaped hold only'],
                                        }))}
                                    />
                                </div>
                                <div className='one-forth' style={{ padding: '0 20px 10px' }}>
                                    <Checkbox 
                                        label='Wooden dunnaging'
                                        style={{ marginTop: '24px', width: '100%' }}
                                        labelStyle={{
                                            fontSize: '12px', fontWeight: 'normal', width: '100%',
                                        }}
                                        iconStyle={{ marginRight: '6px' }}
                                        checked={this.state['Wooden dunnaging']}
                                        onCheck={() => this.changeClauses(JSON.stringify({
                                            name: 'Wooden dunnaging',
                                            value: !this.state['Wooden dunnaging'],
                                        }))}
                                    />
                                </div>
                                <div style={{ padding: '0 20px 10px' }}>
                                    <Checkbox 
                                        label='Pipes with flanges and not streight on ends'
                                        style={{ marginTop: '24px', width: '100%' }}
                                        labelStyle={{
                                            fontSize: '12px', fontWeight: 'normal', width: '100%',
                                        }}
                                        iconStyle={{ marginRight: '6px' }}
                                        checked={this.state['Pipes with flanges and not streight on ends']}
                                        onCheck={() => this.changeClauses(JSON.stringify({
                                            name: 'Pipes with flanges and not streight on ends',
                                            value: !this.state['Pipes with flanges and not streight on ends'],
                                        }))}
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                        :
                        null
                }
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

        const errorWeightValue = cargoOrder.validateErrors
            .find(validateError => validateError.field === 'packing.pack.unitsWeight.value');

        const errorVolumeValue = cargoOrder.validateErrors
            .find(validateError => validateError.field === 'packing.pack.unitsVolume.value');

        const { validateErrors } = cargoOrder;

        return {
            numberOrderTable: ownProps.numberOrderTable,
            cargoOrder,
            errorWeightValue,
            errorVolumeValue,
            validateErrors,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(WeightVolume);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/WeightVolume.jsx